<template>
  <div class="activity align-center-main" v-loading="loading">
    <div class="box2 boxShadow" v-for="(item, index) in textList" :key="index" >
      <div class="state">{{(item.joinEndTime,item.beginTime,item.endTime) | stateFilter(item.joinEndTime,item.beginTime,item.endTime)}}</div>
      <img :src="item.banner+'?imageView2/1/w/535/h/300'" alt="" class="in_b borred"  @click="activityDetails(item.activityId)">
      <div class="content">
        <div class="m_t40 titel ellipse2" @click="activityDetails(item.activityId)">{{item.title}}</div>
        <!-- <p class="jiage m_t20" v-if="item.price === 0"> 价格：免费</p>
        <p class="jiage" v-else> 价格：{{item.price / 100 | PriceFilter}}元</p> -->
        <p class="m_t20"> <i class="iconfont  icon-shijian"></i>  时间：{{item.beginTime | DateFilter('yyyy-MM-dd') }} 至 {{item.endTime | DateFilter('yyyy-MM-dd') }}</p>
        <p class=" address textOver"> <i class="iconfont  icon-dizhi"></i>  地点：{{item.provinceName}}{{item.cityName }}{{item.countyName}}{{item.address}}</p>
        <!-- <p class=""> <i class="iconfont  icon-renshu"></i>  名额：{{item.showNum}} 人</p> -->
        <!-- <div class="BMbtn m_t20"  @click="activityDetails(item.activityId)">报 名</div> -->
      </div>
    </div>

    <div class="fy main-pagination" v-if="msgtotal > 10">
      <el-pagination background layout="prev, pager, next" :total="msgtotal"  @current-change="handleCurrentChange" :page-size="10"></el-pagination>
    </div>

    <Nothing v-if="!textList.length && !loading"></Nothing>

  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return{
      textList: [],
      msgtotal: 0,
      pageIndex: 1,
      loading: true,
    }
  },
  methods:{
    activityDetails(id) {
      this.$router.push({ path: `/navigator/activityDetails/${id}` });
    },
    getActivitylist() {
      this.loading = true;
      this.$http.post(`${this.URL_PREFIX}/app/get/activity/info/list`, {
        currPage: this.pageIndex,
        pageRows: 10,
        parkId: this.currentParkId,
      }).then((res) => {
        this.loading = false;
        if(res.data.resCode === '10000') {
          this.textList = res.data.resData.pageList ? res.data.resData.pageList : [];
          console.log("this.textList",this.textList)
          if (!this.textList.length) {
            this.nothing = true;
          }
          this.msgtotal = res.data.resData && res.data.resData.pageInfo ? res.data.resData.pageInfo.total : 0;
        }
      })
    },
    handleCurrentChange(val) {  // 改变页数
      this.pageIndex = val;
      this.getActivitylist();
    },
  },
  created() {
    this.getActivitylist();
  },
  computed: {
    ...mapGetters(['currentParkId']),
  },
}
</script>
<style scoped lang="scss">
.box2{
  height: 300px;
  display: flex;
  margin-bottom: 20px;
  background-color: #fff;
  .borred{
    border-radius: 4px 0 0 4px;
  }
}
img{
  width: 535px;
  height: 300px;
  position: relative;
  cursor: pointer;
}
.state {
  background-color: #D92121;
  font-size: 16px;
  position: absolute;
  z-index: 999;
  margin-top: 16px;
  color: #fff;
  border-radius: 3px;
  padding: 2px 16px;
}
.content{
  flex: 1;
  box-sizing: border-box;
  padding: 0 0 0 40px;
  .titel{
    font-size: 26px;
    font-weight: 600;
    cursor: pointer;
    // min-height: 60px;
    width: 600px;
  }
}
.iconfont{
  color: #999;
  font-size: 16px;
}
.BMbtn{
  width: 100px;
  height: 32px;
  border-radius: 7px;
  background-color: #D0021b;
  color: #fff;
  line-height: 32px;
  text-align: center;
  font-size: 16px;
  cursor: pointer;
}
.m_l40{
  margin-left: 40px;
}
.m_t40{
  margin-top: 40px;
}
.m_t20{
  margin-top: 20px;
}
.m_t10{
  margin-top: 10px;
}
.titel{
  font-size: 30px;
  cursor: pointer;
  width: 600px;
}
.jiage{
  color:#de2c32;
  font-size: 16px;
  font-weight: 600;
  margin-top: 10px;
}
.fy{
  text-align: center;
  margin-top: 76px;
}
.address{
  width: 600px;
}
</style>




// WEBPACK FOOTER //
// src/pages/navigator/parkCompleteSet/completeSet/Activity.vue